import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert, Input, Row, Col, Container } from "reactstrap";
import { CSSTransition } from "react-transition-group";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faArrowCircleRight, faKey } from '@fortawesome/free-solid-svg-icons'

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import { checkDeviceIOS } from '../../utils'

import logo from './img/logo.png'

const LoginForm = ({ api, location, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = 'tot';

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);

        let message = "USUARIO NAO ENCONTRADO.";

        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message: message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-tot-container" ref={nodeRef}>
        <img src={logo} alt="logo" className="logo-tot rounded mx-auto d-block" />
        <h5>Entretenimiento ¡Donde quieras, cuando quieras!</h5>
        <Form onSubmit={(event) => onSubmit(event)}>
          <Container fluid={true}>
            <Row className="container-input-tot">
              <Col sm="10" xs="10" md="10" className="tot-input">
                <Input
                  className="user-input-tot"
                  disabled={onLogin}
                  placeholder={translate("PlaceholderUserName").toUpperCase()}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="username"
                  onChange={e => setUsername(e.target.value)}
                />
              </Col>
              <Col sm="2" xs="2" md="2" className="tot-icon-lbl my-auto ">
                <FontAwesomeIcon icon={faUser} color="rgba(0,0,0,0.2)" />
              </Col>
            </Row>
          </Container>
          <Container fluid={true}>
            <Row className="container-input-tot">
              <Col sm="10" xs="10" md="10" className="tot-input">
                <Input
                  className="pass-input-tot"
                  required={true}
                  disabled={onLogin}
                  placeholder={translate("PlaceholderPassword").toUpperCase()}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password"
                  onChange={e => setPassword(e.target.value)}
                />
              </Col>
              <Col sm="2" xs="2" md="2" className="tot-icon-lbl my-auto ">
                <FontAwesomeIcon icon={faKey} color="rgba(0,0,0,0.2)" />
              </Col>
            </Row>
          </Container>
          <p className="remember-pass-link">
            <FontAwesomeIcon icon={faArrowCircleRight} color="#1a92cc" />
            <a href="https://mitotalplay.com.mx/" target="_blank" rel="noopener noreferrer">No recuerdo mi contraseña</a>
          </p>
          {!onLogin ? (
            <button
              block={!parameters.failureRedirect}
              tabIndex={1}
              type="submit"
              id="submmit"
              className="enter-tot btn-lg btn-block"
              disabled={!props.turnstileSuccess}
            >
              {translate("ButtonEnter")}
            </button>
          ) : (
            <Progress animated color="danger" value={100} />
          )}
          <p className="tot-text">Para obtener tu cuenta debes ser cliente Totalplay</p>
          {
            checkDeviceIOS() ? '' : <p className="register-pass-link">
              <FontAwesomeIcon icon={faArrowCircleRight} color="#1a92cc" />
              <a href="https://mitotalplay.com.mx/" target="_blank" rel="noopener noreferrer">Soy cliente ¿Cómo me registro?</a>
            </p>
          }

          <p className="tot-text-end">Todos los derechos reservados TOTALPLAY Telecomunicaciones S.A. de C.V. 2025</p>
          <div className="messages-container">
            <Alert
              color="danger"
              id="error-message"
              isOpen={error.open}
              toggle={() => setError({ open: false })}
            >
              {error.message}
            </Alert>
          </div>
        </Form>
      </div>
    </CSSTransition>
  );
}

export default WithCaptcha(LoginForm);
